<div class="flex justify-between header">
  <h2 color="primary">Aggiungi allevamento</h2>
  <button mat-icon-button mat-dialog-close aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<app-dialog-header [denominazione]="praticaProgressService.selectedPratica?.denomination || ''"
  [praticaCode]="praticaProgressService.selectedPratica?.praticaCode || ''"></app-dialog-header>

<mat-dialog-content class="mat-elevation-z2 double-header-dialog-content">
  <smart-form [fields]="fields"></smart-form>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-flat-button class="big" color="accent" [disabled]="!isFormValid" (click)="save()">Salva</button>
</mat-dialog-actions>